import { Button, ButtonProps } from './Button'

export const ButtonIconFilter = (props: ButtonProps) => <Button {...props} iconClassName="icon-filter icon-14px" />
